export const API = process.env.VUE_APP_API_BASE_URL;
export const ApiKey = process.env.VUE_APP_API_KEY;
